import Vue from "vue";
import Vuex from "vuex";

import alertState from "./modules/alert-store";
import authState from "./modules/auth-store";
import pageStore from "./modules/page-store";
import pdfState from "./modules/pdf-store";
import rangeStore from "./modules/range-store";
import recordStore from "./modules/record-store";
import userStore from "./modules/user-store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async init({ rootGetters, dispatch, commit }) {
      dispatch("fetchAllRanges");
      await dispatch("fetchOrganization");
      dispatch("getUserInfo");
    },
  },
  modules: {
    authState,
    pdfState,
    pageStore,
    recordStore,
    rangeStore,
    alertState,
    userStore,
  },
});
